import { QueryClient } from 'react-query';

const CACHE_TIME = 30 * 60 * 1000; // 30 minutes
const STALE_TIME = 10 * 60 * 1000; // 10 minutes

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: CACHE_TIME,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: STALE_TIME,
    },
  },
});
